/*
  Alpha Zen redesign: the readiness quiz stepper.

  From quiz.html: one question at a time, a progress bar, a back link, and a
  personalised result. Per that page's design notes, four things change per
  person, and each is driven by a different answer:

    profile        from the total
    your moment    from when focus drops        (question 2)
    the one change from what they reach for     (question 3)
    journal prompt from how often they present  (question 4)

  The mockup's own <script> was stripped when the archive was imported, so the
  four sets of strings live in the section settings rather than in here, where
  they can be replaced with the original wording without touching this file.
  Only the arithmetic is here: readiness = 100 minus the answers as a
  percentage of the worst possible total.
*/
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-az-quiz]').forEach(function (quiz) {
      if (quiz.dataset.azReady === 'true') return;
      quiz.dataset.azReady = 'true';

      const configEl = quiz.querySelector('[data-az-quiz-config]');
      if (!configEl) return;

      let config;
      try {
        config = JSON.parse(configEl.textContent);
      } catch (error) {
        return;
      }

      const steps = Array.from(quiz.querySelectorAll('.qstep'));
      const stepLabel = quiz.querySelector('[data-az-step-label]');
      const fill = quiz.querySelector('[data-az-fill]');
      const nav = quiz.querySelector('.qnav');
      const back = quiz.querySelector('[data-az-back]');
      const result = quiz.querySelector('[data-az-result]');
      const progress = quiz.querySelector('.qzprog');
      if (!steps.length || !result) return;

      const answers = new Array(steps.length).fill(null);
      let current = 0;

      function pick(list, index) {
        if (!list || !list.length) return '';
        if (index === null || index === undefined) return list[0] || '';
        return list[Math.min(index, list.length - 1)] || '';
      }

      function show(index) {
        current = index;
        steps.forEach(function (step, i) {
          step.classList.toggle('on', i === index);
        });
        if (stepLabel) {
          stepLabel.textContent = config.stepLabel
            .replace('[current]', index + 1)
            .replace('[total]', steps.length);
        }
        if (fill) fill.style.width = ((index + 1) / steps.length) * 100 + '%';
        if (back) back.hidden = index === 0;
      }

      function finish() {
        const total = answers.reduce(function (sum, value) {
          return sum + (value || 0);
        }, 0);
        const worst = steps.length * 3;
        const score = Math.max(0, 100 - Math.round((total / worst) * 100));

        let bandIndex = 0;
        if (score < 40) bandIndex = 3;
        else if (score < 60) bandIndex = 2;
        else if (score < 80) bandIndex = 1;

        const set = function (selector, value) {
          const node = result.querySelector(selector);
          if (node && value) node.textContent = value;
        };

        set('[data-az-score]', String(score));
        set('[data-az-band]', pick(config.bands, bandIndex));
        set('[data-az-profile]', pick(config.profiles, bandIndex));
        set('[data-az-moment]', pick(config.moments, answers[1]));
        set('[data-az-change]', pick(config.changes, answers[2]));
        set('[data-az-prompt]', pick(config.prompts, answers[3]));

        steps.forEach(function (step) {
          step.classList.remove('on');
        });
        if (progress) progress.hidden = true;
        if (nav) nav.hidden = true;
        result.hidden = false;
        result.setAttribute('tabindex', '-1');
        result.focus();
      }

      steps.forEach(function (step, index) {
        step.querySelectorAll('.opts button').forEach(function (option) {
          option.addEventListener('click', function () {
            answers[index] = parseInt(option.dataset.v, 10) || 0;
            step.querySelectorAll('.opts button').forEach(function (other) {
              other.setAttribute('aria-pressed', other === option ? 'true' : 'false');
            });

            if (index + 1 < steps.length) {
              show(index + 1);
            } else {
              finish();
            }
          });
        });
      });

      if (back) {
        back.addEventListener('click', function () {
          if (current > 0) show(current - 1);
        });
      }

      show(0);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
